import { useCallback } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Grid, Button } from "@mui/material";
import LoaderWrapper from "../../../wrapper/LoaderWrapper";
import usePaginationWithSearchParams from "../../../../hooks/usePaginationWithSearchParams";
import useDialogWithId from "../../../../hooks/useDialogWithId";
import { useEmptyArrayMemo } from "../../../../hooks/useEmptyArrayMemo";
import useUserService from "../../../../services/userService";
import OwnerTable from "../../../table/OwnerTable"
import useLocalData from "../../../../hooks/useLocalData";
import { EXTERNAL_OWNER_TABLE_CONFIG } from "./TableConfig";
import { centerVericalAlignIconStyle } from "../../../../helpers/styles";
import ControlPointOutlinedIcon from "@mui/icons-material/ControlPointOutlined";
import ExternalOwnerDialog from "../../../dialog/ExternalOwnerDialog";


const OwnerExternalTab = () => {
  const { t } = useTranslation();

  const [
    openOwnerDetailsDialog,
    selectedOwnerId,
    onOpenOwnerDetailsDialog,
    onCloseOwnerDetailsDialog,
  ] = useDialogWithId();


  const {
    page: ownerDataPage,
    pageSize: ownerDataPageSize,
    handleChangePageWithSearchParams: handleChangeOwnersDataPage,
    handleChangeRowsPerPage,
    resetPageNumber,
    searchParams,
  } = usePaginationWithSearchParams();


  const {
    getExternalOwners
  } = useUserService();

  const {
    data: ownersLocal,
    dataCount: countRecords,
    dataLoading,
    dataRefetch
  } = useLocalData(getExternalOwners, searchParams, true)

  const { emptyArrayMemo } = useEmptyArrayMemo();

  const handleOpenOwnerDetails = useCallback(
    (e, ownerId) => {
      e.stopPropagation();
      onOpenOwnerDetailsDialog(ownerId);
    },
    []
  );


  const onCloseOwnerDialog = useCallback(() => {
    dataRefetch();
    onCloseOwnerDetailsDialog();
  }, []);


  const isLoading = ownersLocal === undefined || countRecords === undefined;

  return (
    <Grid
      container
      item
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      rowSpacing={1}
    >
      <Grid item xs={12} sm={2}>
        <Button
          fullWidth
          variant="contained"
          size="small"
          startIcon={<ControlPointOutlinedIcon sx={centerVericalAlignIconStyle} />}
          onClick={handleOpenOwnerDetails}
        >
          {t("tabs.ico_admin_tabs.add_external_owner")}
        </Button>
      </Grid>
      <Grid item sm={10} />

      <Grid item xs={12}>
        <LoaderWrapper showLoader={isLoading}>
          <OwnerTable
            data={ownersLocal}
            showCheckbox={false}
            showCleanFilterIcon={true}
            countRecords={countRecords}
            page={ownerDataPage}
            onPageChange={handleChangeOwnersDataPage}
            rowsPerPage={ownerDataPageSize}
            onRowsPerPageChange={handleChangeRowsPerPage}
            resetPageNumber={resetPageNumber}
            filteringData={emptyArrayMemo}
            hiddenColumns={emptyArrayMemo}
            columnsOrders={emptyArrayMemo}
            style={{ maxHeight: "vh" }}
            tableConfig={EXTERNAL_OWNER_TABLE_CONFIG}
            showContextMenu={false}
            contextMenuActions={emptyArrayMemo}
            showDetailsIcon={false}
            onClickEdit={handleOpenOwnerDetails}
            hasPermission={true}
            isLoading={dataLoading || isLoading}
          />
        </LoaderWrapper>
      </Grid>

      {openOwnerDetailsDialog && (
              <ExternalOwnerDialog
                open={openOwnerDetailsDialog}
                onClose={onCloseOwnerDialog}
                ownerId={selectedOwnerId}
                readOnly={false}
              />
            )} 

    </Grid>
  );
};

OwnerExternalTab.propTypes = {
  filteringData: PropTypes.object,
};

OwnerExternalTab.defaultProps = {};

export default OwnerExternalTab; 
